document.addEventListener("DOMContentLoaded", function() {
    const headerCart = document.querySelector('.header_cart');
    let cartForm = document.querySelector('#cart-form');
    let cartItem = cartForm.querySelector('.header_cart-head').dataset.items;
    if (cartForm !== null) {
        const headerButtonCart = document.querySelector('.menu_carts.js-open-header-cart');
        const headerButtonCartCount = headerButtonCart.querySelector('.count');
        headerButtonCart.addEventListener('click', function () {
            // headerCart.classList.add('loading');
            // cartRender();
        })
        function updateCart(id, quantity){
            fetch(`${window.routes.cart_change_url}.js`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: id, quantity: quantity })
            }).then(response => {
                if (!response.ok) {
                    return response.text().then(text => { throw new Error(text); });
                }
                return response.json();
            }).then((data) => {
                cartRender();
            }).catch(error => console.error("Error updating cart:", error));

        }
        function cartRender(){
            fetch(window.shopUrl, {
                method: "GET",
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
                .then(response => response.text())
                .then(html => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, "text/html");
                    let newCartForm = doc.querySelector(".header_cart>form");
                    let currentCart = document.querySelector(".header_cart");
                    currentCart.querySelector('form').remove();
                    if (newCartForm ) {
                        currentCart.insertAdjacentElement('afterbegin', newCartForm)
                    }
                    headerButtonCartCount.textContent = newCartForm.querySelector('.header_cart-head').dataset.items;
                    /* - - - - - - - - - - - - - -       init count item   - - - - - - - - - - - - - - - */
                    const countInputs = $("#cart-form .count_input");
                    if (countInputs.length) {
                        countInputs.each(function (i, elem) {
                            const input = $(elem).find("input");
                            const decBtn = $(elem).find(".count_input-dec");
                            const incBtn = $(elem).find(".count_input-inc");

                            const inc = () => {
                                const value = input.val();
                                input.val(+value + 1);
                            };

                            const dec = () => {
                                const value = input.val();

                                if (+value > 0) {
                                    input.val(+value - 1);
                                } else {
                                    input.val(0);
                                }
                            };

                            decBtn.on("click", dec);
                            decBtn.on("keydown", (e) => {
                                if (e.keyCode === 13) {
                                    dec();
                                }
                            });

                            incBtn.on("click", inc);
                            incBtn.on("keydown", (e) => {
                                if (e.keyCode === 13) {
                                    inc();
                                }
                            });
                        });
                    }
                    /* - - - - - - - - - - - - - -       init show note   - - - - - - - - - - - - - - - */
                    $(".js-cart-form-msg-show").on("click", function (e) {
                        e.preventDefault();
                        var $this = $(this);
                        var $parent = $this.closest(".bordered_btn");
                        var $wrapper = $parent.closest(".cart_form-footer-msg");
                        $wrapper.addClass("show")
                    });
                    cartFormEvents();
                    headerCart.classList.remove('loading');
                })
                .catch(error => console.error("Error updating cart:", error));
        }
        function submitCoupon(coupon){
            if(coupon != ''){
                window.location.href = `${window.shopUrl}/checkout?discount=${encodeURIComponent(coupon)}`;
            }
        }
        function cartFormEvents(){
            let debounceTimer;
            let newCartForm = document.querySelector('#cart-form');
            let noteText = newCartForm.querySelector('[name="note"]');
            if (noteText) {
                noteText.addEventListener("blur", function() {
                    headerCart.classList.add('loading');
                    fetch(`${window.routes.cart_update_url }.js`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ note: noteText.value })
                    }).then(() => {
                        headerCart.classList.remove('loading');
                    });
                });
            }

            newCartForm.addEventListener('submit', function (e) {
                e.preventDefault();
                window.location.href = `${window.shopUrl}/checkout`;

            });
            cartForm = document.querySelector('#cart-form');
            cartItem = cartForm.querySelector('.header_cart-head').dataset.items;
            if(cartItem > 0){
                let buttsQuantity = newCartForm.querySelectorAll('.count_input-dec, .count_input-inc');
                buttsQuantity.forEach(function (item) {
                    item.addEventListener('click', function (e){
                        headerCart.classList.add('loading');
                        setTimeout(function () {
                            let itemQuantity = item.closest('.count_input').querySelector('input[name="quantity"]').value;
                            let itemId = item.closest('.count_input').querySelector('input[name="quantity"]').dataset.id;
                            updateCart(itemId, itemQuantity);
                        },500);
                    })
                })
                let inputQuantity  = newCartForm.querySelectorAll('input[name="quantity"]');
                inputQuantity.forEach(function (item) {
                    item.addEventListener('input', function () {
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(() => {
                            headerCart.classList.add('loading');
                            let itemId = item.dataset.id;
                            let itemQuantity = item.value;
                            updateCart(itemId, itemQuantity);
                        }, 500);
                    })
                })
                let buttsRemove = newCartForm.querySelectorAll('[data-remove]');
                buttsRemove.forEach(function (item){
                    item.addEventListener('click',function () {
                        headerCart.classList.add('loading');
                        let id = item.dataset.remove;
                        updateCart(id, 0);
                    })
                })

                let cartCoupon = document.querySelector('.cart_coupon');
                if(cartCoupon !== null){
                    cartCoupon.querySelector('input');
                    if(cartCoupon.querySelector('input').value == ''){
                        cartCoupon.querySelector('.form_apply_coupone').style.pointerEvents = 'none';
                    }
                    cartCoupon.querySelector('input').addEventListener('input', function (e) {
                        if(e.target.value != ''){
                            cartCoupon.querySelector('.form_apply_coupone').style.pointerEvents = 'auto';
                        }else{
                            cartCoupon.querySelector('.form_apply_coupone').style.pointerEvents = 'none';
                        }
                    })
                    cartCoupon.querySelector('.form_apply_coupone').addEventListener('click', function (e) {
                        e.preventDefault();
                        headerCart.classList.add('loading');
                        let coupon = cartCoupon.querySelector('input[name="coupon"]').value;
                        if(coupon != ''){
                            submitCoupon(coupon);
                        }else{
                            headerCart.classList.remove('loading');
                        }
                    })
                }
            }
        }
        cartFormEvents();
    }
});
